import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=4de9c5ac&"
import script from "./Arrivals.vue?vue&type=script&lang=js&"
export * from "./Arrivals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports